import { ApplicationTaskPriority } from '@entities/application/IApplicationTask';
import { ApplicationSubType } from '@app/queries/options/useApplicationBoardSubTypeOptions';
import { ACCOUNT_TYPE } from '@entities/account/IAccount';

export const resolveAccountTypeTitle = (type: ACCOUNT_TYPE) => {
  const items = {
    [ACCOUNT_TYPE.MINING]: 'Майнинг аккаунт',
    [ACCOUNT_TYPE.REFERRAL]: 'Реферальный аккаунт',
    [ACCOUNT_TYPE.AGENT]: 'Агентский аккаунт',
  };

  return items[type];
};
